export const SPOTLIGHT_DISPLAY_TIMEOUT_IN_MILLISECONDS = 1500;

export const spotLightConstants = Object.freeze({
  spotLightDisplayTimeoutInMilliseconds: SPOTLIGHT_DISPLAY_TIMEOUT_IN_MILLISECONDS,
});
